<template>
  <div class="club_page">
    <ClubHeader>
      <template v-slot:club-header-title>
        <h2 class="mar10t">جایزه‌های دریافتی</h2>
      </template>
    </ClubHeader>
    <div class="club-box">
      <div class="custom-box">
        <h2 class="textCenter mar5b">
          امتیاز شما:
          <span class="primary-color mar5r">
            {{ infoItems.score | persian }}
          </span>
        </h2>
        <img src="../../assets/img/diamond.png" alt="score-diamond" class="dBlock marAuto" />
      </div>
      <ClubFooter></ClubFooter>
      <div v-for="(item, index) in bonusDetail" v-bind:key="index">
        <div v-if="item.code">
          <ClubContainer class="mar10t" type="ticket-bg" :style="[
            item.imageUrl
              ? {
                  background:
                    'linear-gradient(to top, rgb(28, 95, 168), rgba(43, 102, 155, 0.7), rgba(0, 92, 147, 0.2), rgba(211, 210, 232, 0), rgb(255, 255, 255)), url(' +
                    item.imageUrl +
                    ') no-repeat center center / cover',
                }
              : {
                  background: '#002664',
                },
          ]">
            <template v-slot:ticket-right>
              <div class="textCenter dFlex f flex-direction-column">
                <div class="primary-color code-box cursor-pointer" v-clipboard="item.code" @click="copyToClipboard()">
                  {{ item.code }}
                </div>
                <p id="copyButton" class="pad5t text-white" style="font-size: 10px;">
                  برای کپی کردن کلیک کنید
                </p>
                <a :href="`/Detail/${item.id}?token=${getToken}`"
                  class="btn-outline text-white text-decoration-none mar5t">
                  مشاهده
                </a>
              </div>
            </template>
            <template v-slot:ticket-left>
              <!--router-link :to="{ path: '/Detail/' + item.Id }"-->
              <div class="bonus-content">
                <p class="primary-btn pad5 b-radiuse20 textCenter w-fit-content">
                  {{ item.title_Bonus | persian }}
                </p>
                <p class="text-white p-absolute mb-0" style="bottom: 10px;">
                  <span>مهلت استفاده تا: </span>{{ item.persianDateEnd | persian }}
                </p>
                <!-- <div class="">
                  <div class="filters dFlex mar10t">
                    <span v-if="item.ImageUrl">
                      <img
                        :src="item.ImageUrl"
                        class="w-100 box-shadow"
                        v-if="item.ImageUrl"
                      />
                    </span>
                    <span v-else>
                      <img
                        src="../../assets/img/logo-bg1.png"
                        class="w-100 b-radiuse5"
                      />
                    </span>
                  </div>
                </div> -->
              </div>
              <!--/router-link-->
            </template>
          </ClubContainer>
          <span id="copyResult"></span>
        </div>
      </div>
    </div>
    <div class="error-message textCenter" v-if="errorMessage">
      {{ errorMessage }}
    </div>
    <div class="success-message textCenter" v-if="successMessage">
      {{ successMessage }}
    </div>
  </div>
</template>

<script>
import ClubHeader from '../../components/Club/Header.vue'
import ClubContainer from '../../components/Club/ScoreContainer.vue'
import api from '../../service'
import ClubFooter from '../../components/Club/ClubFooter.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    ClubHeader,
    ClubContainer,
    ClubFooter,
  },
  data() {
    return {
      hasToken: false,
      infoItems: [],
      scoreItems: [],
      items: [],
      PageSize: '',
      bonusDetail: [],
      errorMessage: false,
      successMessage: false,
      //canCopy:false
    }
  },
  created() {
    //this.canCopy = !!navigator.clipboard;
  },
  computed: {
    ...mapGetters(['getToken']),
  },
  mounted: function () {
    if (this.$route.query.token) {
      this.setToken(this.$route.query.token)
    }
    if (this.$route.query.token) {
      this.$ga.event('club', 'clicked', 'جایزه های دریافتی')

      api.getInfoUserBonus().then((response) => {
        // debugger;
        //console.log(response);
        if (response.data && response.status === 200) {
          this.infoItems = response.data.data.info
          this.scoreItems = response.data.data.scores
        } else {
          if (
            response.data &&
            response.data.messages &&
            response.data.messages.length > 0
          ) {
            this.errorMessage = response.data.messages[0]
          }
        }
      })
      api
        .getBonusDetails({
          PageNo: 1,
          PageSize: 100,
          Type: 5,
        })
        .then((response) => {
          // console.log(response);
          if (response.data && response.status === 200) {
            this.bonusDetail = response.data.data.details
            if (response.data.data.total == 0) {
              this.errorMessage = '.شما تاکنون جایزه‌ای دریافت نکرده‌اید'
            }
          } else if (
            response.data &&
            response.data.messages &&
            response.data.messages.length > 0
          ) {
            this.errorMessage = response.data.messages[0]
          }
        })
        .catch(() => {
          this.errorMessage = 'متاسفانه خطای فنی رخ داده است؛ لطفا دوباره امتحان کنید.'
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  methods: {
    ...mapActions(['setTheme', 'setToken']),
    async copyToClipboard() {
      const answer = document.getElementById('copyResult')
      answer.innerHTML = 'کد با موفقیت کپی شد!'
      answer.classList.add('copy-box')
      setTimeout(function () {
        answer.remove()
      }, 3000)
    },
  },
}
</script>
<style scoped>
.custom-box {
  background: #fff;
  border-bottom: 10px solid #002664;
  margin: -50px 0px 20px;
}

.custom-box img {
  width: 50px;
}

.error-message {
  margin: 10px 20px;
}

.gray-box {
  overflow: hidden;
}
</style>
